<template>
  <UserForm :user="user" :onSubmit="submit"></UserForm>
</template>

<script>
import UserForm from './User-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'edit-user',
  components: {
    UserForm,
  },
  created() {
    this.$store.dispatch('users/getUser', this.$route.params.id);
  },
  computed: {
    user() {
      return this.$store.state.users.user;
    },
  },
  methods: {
    submit() {
      this.$store
        .dispatch('users/updateUser', {
          id: this.$route.params.id,
          body: this.user,
        })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
          this.$router.push({ path: '/users' });
        });
    },
  },
};
</script>
